export default __webpack_public_path__ + "static/media/first-pickup-status.36a8ae71.svg";